import * as types from '../types'

export default (payload) => {
  return {
    type: types.UPDATE_VERSION,
    payload,
  }
}
